// libs
import storage from 'redux-persist/lib/storage'
import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
// reducers
import rootReducer from './reducers'
// types
import { Reducers } from 'store/types'
import { PersistConfig } from 'redux-persist/es/types'

const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  version: 1,
  storage: storage,
  whitelist: [Reducers.CURREN_USER, Reducers.RISK_TEMPLATES, Reducers.RISK_VIEWS],
  blacklist: [
    Reducers.MODALS,
    Reducers.OFFLINE_RISK,
    Reducers.DASHBOARDS,
    Reducers.RISK_VIEWS,
    Reducers.PUBLIC_FORMS,
    Reducers.RELATED_FORMS,
    Reducers.RISK_TEMPLATES,
    Reducers.SECURITY_PROFILES,
    Reducers.SECURITY_PROFILES,
    Reducers.OBJECT_SECURITIES,
    Reducers.ACCUMULATED_FORMS
  ]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }),
  devTools: process.env.NODE_ENV !== 'production'
})

export const persistor = persistStore(store)

export type AppStore = ReturnType<typeof store.getState>
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
